import React, { useState } from 'react'
import { LayoutCard } from 'src/components/commons/LayoutCard'
import { Form } from './Form'
import { Box, useMediaQuery } from '@material-ui/core'
import { Typography } from 'src/components/atoms'
import Image from 'next/image'
import { AfterSent } from './AfterSent'
import theme from 'src/styles/theme'

export const PageSignupOrganization = () => {
  const [sentEmail, setSentEmail] = useState('')
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <LayoutCard
      maxWidth={640}
      justify="center"
      direction="ltr"
      innerCardComponent={
        sentEmail ? <AfterSent email={sentEmail} /> : <Form onSuccessSubmit={email => setSentEmail(email)} />
      }
      isSP={isDownSm}
      isReversedSpDirection
      hideLogo
      outerCardComponent={
        <Box padding={isDownSm ? '0' : '0 20px'}>
          <Box textAlign="center">
            <Typography variant="h3" fontSize="l" fontWeight="bold">
              短期間で効率的な顧客獲得へ
            </Typography>
            <Box mt="4px" />
            <Typography variant="h1" fontSize="xxl" fontWeight="bold">
              ファストセールスをはじめましょう
            </Typography>
          </Box>
          <Box sx={{ position: 'relative', overflow: 'hidden' }} height={isDownSm ? '200px' : '400px'}>
            <Image alt="" src="/images/team-signup.svg" layout="fill" objectFit="contain" />
          </Box>
          <Box position="relative" height="152px">
            <Image alt="" src="/images/team-signup-list.png" layout="fill" objectFit="contain" />
          </Box>
        </Box>
      }
      innerCardProps={{
        height: 'auto'
      }}
    />
  )
}
